
import {getGgr} from '../api/getGgr';
import {setGetGgrAction} from '../action';

const setGetGgr = (params ) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getGgr(params);

            if (data.status === 'success') {
                dispatch(setGetGgrAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetGgr
}